import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const PinComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__pin"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.92 4.21053L5.28 2H10.72L10.08 4.21053V5.86842C12 6.60526 12 9 12 9H4C4 9 4 6.60526 5.92 5.86842V4.21053Z"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 9L8 14" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const Pin = withIcon(PinComponent);
